import * as types from './actionTypes';  
import userConfirmApi from '../api/userReconfirmApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2'

export function doUserConfirm(data) {
  return {
    type: types.DO_USER_CONFIRM, 
    data
  };
}

export function doUserConfirmRes(data) {  
  return {
    type: types.DO_USER_CONFIRM_RES, 
    data
  };
}

export function user_confirm(data) {
  const TOKEN = getItem('auth_token');
  if(TOKEN){
    return function(dispatch) {
      userConfirmApi.doUserConfirm(data).then(data => {
        dispatch(doUserConfirmRes(data));
        dispatch(doUserConfirmRes(null));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          })
        }
      }).catch(error => {
        return error
      });
    };
  }else{
    logout()
  }
}